// Generated by GitHub Copilot
import { AuthGuard } from '#components/tools/auth-guard.tsx'
import { NotFoundPage } from '#components/tools/not-found-page.tsx'
import { CompanyLessPath } from '#components/domain/auth/user/shared/company-less-path.tsx'
import { CompanyUnlockScreen } from '#components/entities/users/company-lock/company-unlock-screen.tsx'
import { AssumedCompanyFrame } from '#components/primitives/components/assumed-company-frame.tsx'
import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * Pathless layout route that wraps all settings pages with authentication.
 * Mirrors the auth guard used by the main `_app` layout, but renders a
 * settings-specific shell instead of the main app sidebar.
 */
export const Route = createFileRoute('/_appSettings')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <AuthGuard
      navigateToLoginOnFailure={true}
      noAccess={<CompanyLessPath fallback={<NotFoundPage />} />}
      locked={(companyId) => <CompanyUnlockScreen companyId={companyId} />}
    >
      {/* Danger ring + "logged in as" label while a super user works inside another company. */}
      <AssumedCompanyFrame />
      <Outlet />
    </AuthGuard>
  )
}
